import { lazy, Suspense } from 'react';
import Loader from 'components/Loader';
import type { CodeEditorProps } from './CodeEditorInner';

const CodeEditorInner = lazy(() => import('./CodeEditorInner'));

const CodeEditor = (props: CodeEditorProps) => {
  const height = props.height ?? '200px';
  return (
    <Suspense
      fallback={
        <div style={{ height, minHeight: 100, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <Loader />
        </div>
      }
    >
      <CodeEditorInner {...props} />
    </Suspense>
  );
};

export default CodeEditor;
